import React from "react";
import Page from "./page";

export function Index(props) {

  return (
    <Page />
  );
}

export default Index;